/* External dependencies */
import { gql } from '@apollo/client';

export const updateProfileMutation = gql`
  mutation updateProfile($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      identificationStatus
      identificationDocument {
        id
        identificationData {
          pin
          documentNumber
          front
          back
          selfie
        }
      }
    }
  }
`;
